import filters from './index';

const InvFilters = {
    install(Vue, options) {
        filters(Vue, options);
    }
};

export default InvFilters;